import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import ReduxFormField from '../../common/forms/ReduxFormsField';
import VideoUploader from '../../common/components/VideoUploader';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';
import CropperScaffold from '../../common/forms/CropperScaffold';
import CheckboxBoolean from '../../common/forms/CheckboxBoolean';

const validate = values => {
  const errors = {};
  const { name, description, pre_requisite_course_id, pre_requisite_lesson_id, video, image } = values;

  if (!name || !name.trim()) {
    errors.name = ['Name is required'];
  } else if (name.trim().length > 255) {
    errors.name = ['Name cannot be longer than 255 characters'];
  }

  if (description && description.trim().length > 255) {
    errors.description = ['Description cannot be longer than 255 characters'];
  }

  if (pre_requisite_course_id && !pre_requisite_lesson_id) {
    errors.pre_requisite_lesson_id = ['A lesson requirement must be selected if a course requirement is present'];
  }

  if (!video) {
    errors.video = ['A video is required'];
  }

  if (!image) {
    errors.image = ['A thumbnail image is required'];
  }

  return errors;
};

class EditVideoForm extends Component {
  render() {
    const {
      videoUploadProgress,
      videoUploading,
      courses,
      lessons,
      handleRemoveImage,
      activeRecord,
      clearOrigImage,
      handleSubmit,
    } = this.props;

    const courseOptions = courses
      ? courses.map(course => {
          return (
            <option key={course.get('id')} value={course.get('id')}>
              {course.get('name')}
            </option>
          );
        })
      : null;

    const lessonOptions = lessons
      ? lessons.map(lesson => (
          <option key={lesson.get('id')} value={lesson.get('id')}>
            {lesson.get('name')}
          </option>
        ))
      : null;

    const imageField =
      activeRecord.get('image_id') && !clearOrigImage ? (
        <CropperScaffold label="Video Thumbnail" required>
          <div className="original-image">
            <img alt="video logo" src={activeRecord.getIn(['image', 'location'])} />
          </div>
          <div className="cropper-scaffold__controls">
            <button type="button" className="button button--theme--outline" onClick={handleRemoveImage}>
              Remove Image
            </button>
          </div>
        </CropperScaffold>
      ) : (
        <Field name="image" component={ReduxFormsImageCropper} label="Video Thumbnail" />
      );

    const lessonSelectDisabled = !(lessons && lessons.size);

    return (
      <form className="edit-video__form" onSubmit={handleSubmit(this.props.onSubmit)}>
        <div className="form-header">
          <h4>Video Details</h4>
          <p className="p">Enter video details here</p>
        </div>
        <div className="relate-course">
          <h4>Relate Video to a Course</h4>
          <Field
            onChange={this.props.handleCourseChange}
            name="pre_requisite_course_id"
            component={ReduxFormField}
            label="Select Course"
            required
          >
            <select>
              <option value="">None</option>
              {courseOptions}
            </select>
          </Field>
          <Field
            name="pre_requisite_lesson_id"
            component={ReduxFormField}
            label="Select Lesson"
            disabled={lessonSelectDisabled}
            required={!lessonSelectDisabled}
          >
            <select>
              <option value="">None</option>
              {lessonOptions}
            </select>
          </Field>
        </div>
        <Field name="name" component={ReduxFormField} label="Video Title" required={true}>
          <input type="text" />
        </Field>
        <Field name="description" component={ReduxFormField} label="Video Description">
          <input type="text" />
        </Field>
        <VideoUploader
          labelText="Video"
          onVideoUpload={this.props.handleVideoUpload}
          uploading={videoUploading}
          uploadProgress={videoUploadProgress}
          video={activeRecord.get('video_id') ? activeRecord.get('video') : null}
        />
        {imageField}
        <div className="admin-paper__edit-content__button-row">
          <div>
            <Field name="active" component={ReduxFormField} label="Enable" required={true}>
              <CheckboxBoolean />
            </Field>
          </div>
          <div>
            <button type="button" className="button button--theme--plain" onClick={this.props.onCancel}>
              Cancel
            </button>
            <button type="submit" className="button">
              Save
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'editVideoForm',
  onSubmitFail: () => {
    window.scrollTo(0, 0);
  },
  validate,
})(EditVideoForm);



// WEBPACK FOOTER //
// ./src/library/video/EditVideoForm.js